import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidemenu from "../base/sidemenu";
import { deleteAdmin } from "../../services/adminService";
import "./AdminDetailRedesign.css";

export default function AdminDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const admin = location.state?.admin || {};
  const token = localStorage.getItem("token");

  const handleGoBack = () => navigate(-1);

  const handleDelete = async () => {
    if (!window.confirm("정말 이 관리자를 삭제하시겠습니까?")) return;

    try {
      const result = await deleteAdmin(admin.id, token);

      if (result.success === false) {
        alert(result.message);
        return;
      }

      alert(result.message);
      navigate("/admin");
    } catch (error) {
      console.error("삭제 실패:", error);
      alert("관리자 삭제에 실패했습니다.");
    }
  };

  const fields = [
    ["이름", admin.name],
    ["아이디", admin.username],
    ["권한", admin.auth_name],
    ["소속", admin.department],
    ["휴대폰 번호", admin.mobile_phone],
    ["내선번호", admin.phone],
    ["이메일", admin.email],
    ["최근 접속", admin.last_login]
  ];

  return (
    <div className="flex admin-detail-redesign-layout">
      <Sidemenu />

      <main className="admin-detail-redesign-content">
        <div className="ad-page">
          <div className="ad-top">
            <button className="ad-back" onClick={handleGoBack}>
              ← 관리자 목록
            </button>
          </div>

          <div className="ad-heading">
            <h2>관리자 상세정보</h2>
            <p>관리자 계정 및 소속 정보를 확인할 수 있습니다.</p>
          </div>

          <section className="ad-card">
            <div className="ad-card-title">
              <h3>관리자 기본 정보</h3>
              <span>관리자 계정 및 연락처 정보</span>
            </div>

            <div className="ad-info-grid">
              {fields.map(([label, value]) => (
                <div className="ad-info-item" key={label}>
                  <span>{label}</span>
                  <strong>
                    {String(value ?? "").trim() || "-"}
                  </strong>
                </div>
              ))}
            </div>
          </section>

          <div className="ad-actions">
            <button
              className="ad-danger"
              onClick={handleDelete}
            >
              삭제
            </button>

            <button
              className="ad-secondary"
              onClick={() =>
                navigate("/admin/edit", { state: { admin } })
              }
            >
              수정
            </button>

            <button
              className="ad-primary"
              onClick={handleGoBack}
            >
              확인 · 목록으로
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
